export default __webpack_public_path__ + "static/media/digna-tutorial-4.a3015f26.gif";